import React, {useRef, useState, useEffect, useCallback} from 'react'
import classNames from 'classnames'
import {Button, Fade, Paper, Popper} from '@mui/material'
import ClickAwayListener from '@mui/material/ClickAwayListener'

import {ImageCollections} from '../../utils/imageImports'
import NotificationCountBadge from '../common/NotificationCountBadge/NotificationCountBadge'
import NotificationPopper from './NotificationPopper'
import {useNotificationCount} from '../../hooks/useNotificationCount'

import './notification.scss'

const Notification = () => {
  const [showPopper, setShowPopper] = useState(false)
  const anchorRef = useRef<HTMLButtonElement | null>(null)

  const {displayCount, acknowledge} = useNotificationCount({poll: true})

  const handleToggle = useCallback((open: boolean) => {
    setShowPopper(open)
  }, [])

  useEffect(() => {
    if (showPopper) acknowledge()
  }, [showPopper, acknowledge])

  return (
    <div className="header-notification">
      <Button
        ref={anchorRef}
        className={classNames('user-btn', {active: showPopper})}
        aria-haspopup="true"
        onClick={() => handleToggle(true)}
        data-testid="header-notification"
      >
        <img
          src={ImageCollections.ico_bell}
          alt="Notification icon"
          className="bell-icon"
        />
        <NotificationCountBadge count={displayCount} />
      </Button>

      <Popper
        open={showPopper}
        anchorEl={anchorRef.current}
        transition
        placement="bottom-end"
        disablePortal
        className="header-notification-pop"
      >
        {({TransitionProps}) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className="notification-paper">
              <span className="arrow-tip" />
              <ClickAwayListener onClickAway={() => handleToggle(false)}>
                <NotificationPopper handleToggle={handleToggle} />
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  )
}

export default React.memo(Notification)
